// Module
var code = "<td data-bind=\"css: { invalidConsequenceResult: !isValid && !isNaN}\">\n    <span data-bind=\"text: valueText\"></span>\n    <!-- ko if: !isNaN && !isValid-->\n    <span class=\"icon iconHelp blue pointercursor\" data-bind=\"click: toggleHelpTooltip, clickOutside: hideHelpTooltip\"></span>\n    <!-- /ko -->\n</td>\n";
// Exports
module.exports = code;